import { put, select, takeLatest } from "redux-saga/effects"
import { Types as LoaderTypes } from "model/graphql"
import { Creators as analyzeBetaCreators } from "modules/analyze-beta-details/model"
import { chain, get } from "lodash"

function* handleLoadSuccess({ resource, data }) {
  if (resource === "groupedBetaContributors") {
    const { selectedGroup } = yield select(state => ({
      selectedGroup: get(state, "modules.analyzeBetaDetails.selectedGroup"),
    }))

    if (selectedGroup) {
      const selectedGroupExists = chain(data)
        .get("model.simulation.groupedBetaContributors.0.groupedContributors")
        .some(item => item.id === selectedGroup.id)
        .value()

      if (!selectedGroupExists) {
        yield put(analyzeBetaCreators.hideGroup())
      }
    }
  }
}

export function* saga() {
  yield takeLatest(LoaderTypes.LOAD_SUCCESS, handleLoadSuccess)
}
